import React from "react";
import "./Frame11722.css";

function Frame11722(props) {
  const { children } = props;

  return (
    <div className="frame-117-1">
      <div className="process-view valign-text-middle inter-medium-star-dust-18px">{children}</div>
    </div>
  );
}

export default Frame11722;
